import React from "react";

export default function DatasetBlock(props) {
    const {dataset} = props;
    return (
        <div className="flex items-center space-x-3 mb-3">
            <h3 className="text-neutral-800 text-xl font-bold truncate">{dataset.title}</h3>
            <span className="index-corpus-category-badge flex">
                      <a href={ dataset.meta.paper_url } target="_blank" title={ dataset.meta.paper_title }>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             className="h-5 w-5 font-normal hover:text-neutral-700 text-neutral-400" fill="none"
                             viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                          <path strokeLinecap="round" strokeLinejoin="round"
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                        </svg>
                      </a>
                      <a href={ dataset.meta.dataset_download_link } target="_blank" title="Download the dataset.">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             className="h-5 w-5 font-normal hover:text-neutral-700 text-neutral-400" fill="none"
                             viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                          <path strokeLinecap="round" strokeLinejoin="round"
                                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                        </svg>
                      </a>
                  </span>
        </div>
    )
}